import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// src/lib/utils.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=utils.js.map
//# sourceMappingURL=utils.js.map